import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { VehicleFingerprintDashboard, VehicleFingerprintDashboardRequest, VehicleFingerprintContext } from './vehicle-fingerprint.models';
import { getFingerprintDates } from './vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint',
  templateUrl: './vehicle-fingerprint.component.html',
  styleUrls: ['./vehicle-fingerprint.component.css']
})
export class VehicleFingerprintComponent implements OnInit {
  readonly requestForm = new FormGroup({
    iSystemUser: new FormControl(0),
    strSession: new FormControl(''),
    strUnitID: new FormControl(''),
  });

  loading = false;
  dashboard: VehicleFingerprintDashboard | null = null;
  context: VehicleFingerprintContext = { summary: null, unitId: '' };

  constructor(
    private readonly route: ActivatedRoute,
    private readonly gurdService: GurdServiceService,
    private readonly notification: NotificationService,
    private readonly router: Router,
    private readonly location: Location,
    private readonly other: OtherService,
  ) { }

  ngOnInit(): void {
    this.requestForm.patchValue({
      iSystemUser: Number(this.gurdService.decrypt(localStorage.getItem('ID'))),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')),
      strUnitID: this.route.snapshot.paramMap.get('id') || '',
    });
    const { iSystemUser, strSession, strUnitID } = this.requestForm.value;
    if (!Number.isInteger(iSystemUser) || iSystemUser <= 0 || !strSession || !strUnitID) {
      this.notification.showError('اطلاعات نشست یا شناسه خودرو معتبر نیست.');
      return;
    }
    void this.loadDashboard();
  }

  async loadDashboard(): Promise<void> {
    if (this.loading) return;
    this.dashboard = null;
    this.context = { summary: null, unitId: this.requestForm.value.strUnitID };
    this.loading = true;
    try {
      const payload: VehicleFingerprintDashboardRequest = this.requestForm.value;
      const response = await axios.post('Fraud_VehicleFingerprint_Dashboard_Get', payload, {
        timeout: 30000,
      });
      const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      if (!data || typeof data !== 'object') throw new Error('قالب پاسخ سرویس معتبر نیست.');
      if (data.ISSessionExpired || data.ISessionExpired) {
        this.handleExpiredSession();
        return;
      }
      if (data.iResult !== undefined && Number(data.iResult) !== 1) {
        this.notification.showError(data.strError || 'دریافت اطلاعات اثر انگشت خودرو با خطا مواجه شد.');
        this.goBack();
        return;
      }
      if (!Array.isArray(data.Table)) throw new Error('قالب پاسخ سرویس معتبر نیست.');
      this.dashboard = data as VehicleFingerprintDashboard;
      this.context = {
        summary: this.dashboard.Table[0] || null,
        unitId: payload.strUnitID,
        dates: getFingerprintDates(this.dashboard),
        dailyPower: Array.isArray(this.dashboard.Table1) ? this.dashboard.Table1 : [],
        dailySpeed: Array.isArray(this.dashboard.Table2) ? this.dashboard.Table2 : [],
        dailyMovement: Array.isArray(this.dashboard.Table4) ? this.dashboard.Table4 : [],
        dailyActivity: Array.isArray(this.dashboard.Table3) ? this.dashboard.Table3 : [],
        dailyQuality: Array.isArray(this.dashboard.Table5) ? this.dashboard.Table5 : [],
      };
    } catch (error) {
      this.notification.showError(error instanceof Error && !('isAxiosError' in error)
        ? error.message : 'دریافت اطلاعات اثر انگشت خودرو با خطا مواجه شد.');
    } finally {
      this.loading = false;
    }
  }

  private handleExpiredSession(): void {
    this.notification.showError('لطفا وارد سیستم شوید');
    this.other.removeLocalStorage();
    void this.router.navigate(['login'], { queryParams: { error: 'لطفا وارد سیستم شوید' } });
  }

  goBack(): void {
    this.location.back();
  }

}
